import { exists } from '@/api'

export interface BatchCollectionMgmtListByCollectionConditionListItem {
  acceptDateFrom: string
  acceptDateTo: string
  status: string
  holdingBranch: string
  rdoOutputType: string
  memo: string
  batchType: string
}

export function BatchCollectionMgmtListByCollectionConditionListItemFromJSON(
  json: any
): BatchCollectionMgmtListByCollectionConditionListItem {
  const resp = JSON.parse(json)

  return {
    acceptDateFrom: exists(resp, 'accept_date_from')
      ? resp.accept_date_from
      : '',
    acceptDateTo: exists(resp, 'accept_date_to') ? resp.accept_date_to : '',
    status: exists(resp, 'status') ? resp.status : '',
    holdingBranch: exists(resp, 'holding_branch') ? resp.holding_branch : '',
    rdoOutputType: exists(resp, 'rdo_output_type') ? resp.rdo_output_type : '1',
    memo: exists(resp, 'memo') ? resp.memo : '',
    batchType: resp.batch_type
  }
}
